import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c1c6a58")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("table", null, [
    _createVNode("thead", null, [
      _createVNode("tr", null, [
        _createVNode("th", null, [
          _createVNode("img", {
            class: "icon",
            src: $props.browser.icon,
            alt: $props.browser.name
          }, null, 8, ["src", "alt"])
        ]),
        _createVNode("th", null, _toDisplayString($props.browser.name), 1)
      ])
    ]),
    _createVNode("tbody", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.browser.versions, (coverage, version) => {
        return (_openBlock(), _createBlock("tr", { key: version }, [
          _createVNode("td", null, _toDisplayString(version), 1),
          _createVNode("td", null, _toDisplayString(coverage), 1)
        ]))
      }), 128))
    ])
  ]))
})